import { Component, DestroyRef, inject, OnInit } from '@angular/core';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import { MsalService } from '@azure/msal-angular';
import { ElasticApmService } from '../../services/elastic-apm.service';
import { AuthError } from '@azure/msal-browser';

/**
 * Custom MSAL redirect component that sets navigateToLoginRequestUrl: false,
 * preserving the MSAL v4 behavior where MSAL does not navigate away from /redirect
 * after handling the redirect. This allows RedirectComponent to control navigation
 * to the appropriate dashboard after login, preventing race conditions.
 */
@Component({
  selector: 'app-custom-redirect',
  standalone: true,
  template: ''
})
export class CustomMsalRedirectComponent implements OnInit {
  private readonly destroyRef = inject(DestroyRef);
  private readonly authService = inject(MsalService);
  private readonly elasticApmService = inject(ElasticApmService);

  ngOnInit(): void {
    this.authService
      .handleRedirectObservable({ navigateToLoginRequestUrl: false })
      .pipe(takeUntilDestroyed(this.destroyRef))
      .subscribe({
        error: (e: AuthError) => {
          this.elasticApmService.logError(e.name, `${e.errorCode}: ${e.message}`);
        }
      });
  }
}
